/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import MaskedInput from 'react-text-mask';

import { RenderTextField } from './FormTextField';

import { Field } from 'formik';

const useStyles = makeStyles()((theme) => ({
  formControl: {
    margin: theme.spacing(1),
  },
}));

export const TextMaskCustom = React.forwardRef((props, ref) => {
  return <MaskedInput {...props} />;
});

export const FormTextFieldWithMask = ({ name, type, placeholder, mask, innerInputProps, ...others }) => {
  const { classes } = useStyles();
  return (
    <Field
      name={name}
      component={RenderTextField}
      className={classes.formControl}
      inputProps={{
        type,
        placeholder,
        inputComponent: TextMaskCustom,
        inputProps: { mask, ...innerInputProps },
      }}
      {...others}
    />
  );
};
